import axios from 'axios'

const AccountService = {
  async init() {
    return axios.post('account/init')
  },

  async register(info) {
    return axios.post('register', info)
  },

  async contactUs(info) {
    return axios.post('contactUs', info)
  },

  async login(info) {
    return axios.post('login', info)               // -> https://.../api/login
  },

  async forgotPassword(email) {
    // accepts "foo@bar.com" or { email: "foo@bar.com" }
    const payload = typeof email === 'string' ? { email } : (email || {})
    return axios.post('password/email', payload)
  },

  async resetPassword(info) {
    return axios.post('password/reset', info)
  },

  async fetchRoles() {
    return axios.get('user/roles')                 // ❌ no leading slash
  },

  async fetchCustomerRoles() {
    return axios.get('user/customer-roles')        // ❌ no leading slash
  },

  setUserToken(token) {
    localStorage.setItem('token', token)
    // your global interceptor already reads from localStorage & sets the header
  }
}

export default AccountService
